import React, { useEffect } from "react";
import "./Toast.css";

const Toast = ({ message, type = "info", onClose, duration = 3000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case "success": return "✅";
      case "error": return "⚠️";
      case "info": return "ℹ️";
      default: return "";
    }
  };

  return (
    <div className={`toast show ${type}`}>
      <div className="toast-content">
        <span className="toast-icon">{getIcon()}</span>
        <span>{message}</span>
      </div>
      <button className="toast-close" onClick={onClose}>×</button>
    </div>
  );
};

export default Toast;
